import React from 'react';
// import { SvgXml } from 'react-native-svg';

export default function Success({ color = '#BDBDBD', fill = 'none' }) {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.5 24.9302V27.0002C49.4972 31.8521 47.9261 36.5732 45.021 40.4593C42.1159 44.3454 38.0324 47.1883 33.3796 48.564C28.7267 49.9397 23.7538 49.7745 19.2026 48.093C14.6513 46.4115 10.7655 43.3039 8.12466 39.2336C5.48385 35.1633 4.22953 30.3483 4.54877 25.5069C4.86802 20.6655 6.74372 16.0569 9.89613 12.3686C13.0485 8.68028 17.3088 6.10979 22.0414 5.04051C26.7741 3.97123 31.7256 4.46044 36.1575 6.43518"
        stroke="#29D890"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.5 9L27 31.5225L20.25 24.7725"
        stroke="#29D890"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  // return <SvgXml xml={xml} />;
}
